import { DeviceHealthCountsModel } from '@em/models/restapi/DeviceHealthCounts.Model';
import { CollectionModel } from '@shared/models/restapi/Collection.Model';

export class DeviceHealthCountsCollectionModel extends CollectionModel<DeviceHealthCountsModel> {
    public constructor() {
        super(DeviceHealthCountsModel);
    }
}
